// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/auth/v1/auth.proto (package mono.auth.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateUserRequest, CreateUserResponse, DeleteUserRequest, DeleteUserResponse, GetJWKSRequest, GetJWKSResponse, GetMeRequest, GetMeResponse, GetProvidersRequest, GetProvidersResponse, GetSharePointOAuthConfigRequest, GetSharePointOAuthConfigResponse, GetSSOConfigRequest, GetSSOConfigResponse, GetUserRequest, GetUserResponse, ListUsersForSharingRequest, ListUsersForSharingResponse, ListUsersRequest, ListUsersResponse, LoginRequest, LoginResponse, LogoutRequest, LogoutResponse, RefreshRequest, RefreshResponse, RegisterRequest, RegisterResponse, ResolveUserNamesRequest, ResolveUserNamesResponse, UpdateSSOConfigRequest, UpdateSSOConfigResponse, UpdateUserPasswordRequest, UpdateUserPasswordResponse, UpdateUserRequest, UpdateUserResponse, UpdateUserRoleRequest, UpdateUserRoleResponse, UpdateUserStatusRequest, UpdateUserStatusResponse } from "./auth_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * AuthService provides identity and authentication operations.
 * Note: OAuth/SAML redirect flows remain HTTP-only since they require browser redirects.
 *
 * @generated from service mono.auth.v1.AuthService
 */ export const AuthService = {
    typeName: "mono.auth.v1.AuthService",
    methods: {
        /**
     * Login authenticates a user with email and password.
     *
     * @generated from rpc mono.auth.v1.AuthService.Login
     */ login: {
            name: "Login",
            I: LoginRequest,
            O: LoginResponse,
            kind: MethodKind.Unary
        },
        /**
     * Register creates a new user account.
     *
     * @generated from rpc mono.auth.v1.AuthService.Register
     */ register: {
            name: "Register",
            I: RegisterRequest,
            O: RegisterResponse,
            kind: MethodKind.Unary
        },
        /**
     * Refresh exchanges a refresh token for new access/refresh tokens.
     *
     * @generated from rpc mono.auth.v1.AuthService.Refresh
     */ refresh: {
            name: "Refresh",
            I: RefreshRequest,
            O: RefreshResponse,
            kind: MethodKind.Unary
        },
        /**
     * Logout invalidates the current session.
     *
     * @generated from rpc mono.auth.v1.AuthService.Logout
     */ logout: {
            name: "Logout",
            I: LogoutRequest,
            O: LogoutResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetMe returns the current authenticated user's profile.
     *
     * @generated from rpc mono.auth.v1.AuthService.GetMe
     */ getMe: {
            name: "GetMe",
            I: GetMeRequest,
            O: GetMeResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetProviders returns available SSO providers for a tenant.
     *
     * @generated from rpc mono.auth.v1.AuthService.GetProviders
     */ getProviders: {
            name: "GetProviders",
            I: GetProvidersRequest,
            O: GetProvidersResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetJWKS returns the JSON Web Key Set for token verification.
     *
     * @generated from rpc mono.auth.v1.AuthService.GetJWKS
     */ getJWKS: {
            name: "GetJWKS",
            I: GetJWKSRequest,
            O: GetJWKSResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListUsersForSharing returns users available for sharing within a tenant.
     *
     * @generated from rpc mono.auth.v1.AuthService.ListUsersForSharing
     */ listUsersForSharing: {
            name: "ListUsersForSharing",
            I: ListUsersForSharingRequest,
            O: ListUsersForSharingResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSSOConfig returns SSO configuration for the current tenant.
     *
     * @generated from rpc mono.auth.v1.AuthService.GetSSOConfig
     */ getSSOConfig: {
            name: "GetSSOConfig",
            I: GetSSOConfigRequest,
            O: GetSSOConfigResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateSSOConfig updates SSO configuration for the current tenant.
     *
     * @generated from rpc mono.auth.v1.AuthService.UpdateSSOConfig
     */ updateSSOConfig: {
            name: "UpdateSSOConfig",
            I: UpdateSSOConfigRequest,
            O: UpdateSSOConfigResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSharePointOAuthConfig returns ONLY the public SharePoint OAuth-start
     * fields needed by clients to build the authorize URL — no client_secret,
     * ever. Authorized by Cerbos `connect` action on `sharepoint_oauth_settings`,
     * which the policy allows for any role within the user's tenant.
     *
     * @generated from rpc mono.auth.v1.AuthService.GetSharePointOAuthConfig
     */ getSharePointOAuthConfig: {
            name: "GetSharePointOAuthConfig",
            I: GetSharePointOAuthConfigRequest,
            O: GetSharePointOAuthConfigResponse,
            kind: MethodKind.Unary
        }
    }
};
/**
 * UserManagementService provides admin user management operations.
 * All RPCs require a valid X-Admin-Secret header (shared secret auth, not JWT).
 *
 * @generated from service mono.auth.v1.UserManagementService
 */ export const UserManagementService = {
    typeName: "mono.auth.v1.UserManagementService",
    methods: {
        /**
     * ListUsers returns users with pagination, search, and optional tenant filter.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.ListUsers
     */ listUsers: {
            name: "ListUsers",
            I: ListUsersRequest,
            O: ListUsersResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetUser returns a single user by ID.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.GetUser
     */ getUser: {
            name: "GetUser",
            I: GetUserRequest,
            O: GetUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateUser creates a new user account with a specified role.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.CreateUser
     */ createUser: {
            name: "CreateUser",
            I: CreateUserRequest,
            O: CreateUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateUserRole changes a user's role.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.UpdateUserRole
     */ updateUserRole: {
            name: "UpdateUserRole",
            I: UpdateUserRoleRequest,
            O: UpdateUserRoleResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateUserStatus activates or deactivates a user.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.UpdateUserStatus
     */ updateUserStatus: {
            name: "UpdateUserStatus",
            I: UpdateUserStatusRequest,
            O: UpdateUserStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateUser edits a user's profile fields (name, email). Polish task 04.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.UpdateUser
     */ updateUser: {
            name: "UpdateUser",
            I: UpdateUserRequest,
            O: UpdateUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * UpdateUserPassword sets a new password for a user (admin reset). Polish
     * task 04 — replaces the express /api/user/:id/password route.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.UpdateUserPassword
     */ updateUserPassword: {
            name: "UpdateUserPassword",
            I: UpdateUserPasswordRequest,
            O: UpdateUserPasswordResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteUser deactivates (soft-deletes) a user by default; set hard=true for
     * a permanent delete, which writes a durable audit record (R18).
     *
     * @generated from rpc mono.auth.v1.UserManagementService.DeleteUser
     */ deleteUser: {
            name: "DeleteUser",
            I: DeleteUserRequest,
            O: DeleteUserResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveUserNames batch-resolves user ids to display names. Deliberately
     * narrower than GetUser/ListUsers - it returns ONLY id and display_name
     * (no email, roles, scopes, or tenant_id) since its sole purpose is the
     * admin-console id-to-name fan-out (nameResolution.tsx's useAdminNames),
     * which never needed more than that. Unknown or foreign-tenant ids are
     * simply absent from the response, matching GetUser's treatment of deleted
     * users - the caller cannot tell "unknown id" from "not yours to see".
     * Capped at 100 ids per call (mirrors the frontend's MAX_USER_RESOLUTIONS);
     * exceeding the cap returns InvalidArgument.
     *
     * @generated from rpc mono.auth.v1.UserManagementService.ResolveUserNames
     */ resolveUserNames: {
            name: "ResolveUserNames",
            I: ResolveUserNamesRequest,
            O: ResolveUserNamesResponse,
            kind: MethodKind.Unary
        }
    }
};
